<form [formGroup]="form">
  <input 
    formControlName="date"
    type="date" 
    [max]="maxDateString_()"
  />
  @if (isMaxDateExceeded()) {
    <div class="error-message">
      <ods-icon class="error-message-icon" variant="error"/>
      <span>Date cannot be a future date.</span>
    </div>
  }    
</form>